import { useDataModel } from '@thd-nucleus/data-sources';

export const useSubmitAnswer = (formData) => {
  const [submitAnswerForm, response] = useDataModel('submitAnswer', {
    lazy: true,
    variables: formData
  });

  return [
    submitAnswerForm,
    response
  ];
};
